import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/apps/behes.dev/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apps/behes.dev/src/components/studio/ContactPanel.jsx");
